// extracted by mini-css-extract-plugin
module.exports = {"Radio":"Radio_Radio__2S4D5","labelInMiddleMode":"Radio_labelInMiddleMode__1BdOi","value":"Radio_value__1yVVv","label":"Radio_label__2UaHu"};